import { IEntity } from '@infodata-group/inf-commons';
import * as uuid from 'uuid';
import { ReportDetailExportInterface } from '../../interface/report/report-detail-export.interface';

export class AoReportDetail implements IEntity {
  public id = uuid.v4();
  lock: boolean;
  heureDebut: string;
  heureFin: string;
  duree: string;
  km = 0;
  position: string;
  latitude: number;
  longitude: number;
  adresse: string;
  private chantier: any;

  public getChantier(): any {
    return this.chantier;
  }

  public setChantier(site: any) {
    this.chantier = site;
    if (site.color) {
      this.dataTableColor = `${site.color}99`;
    }
  }

  chauf: string;
  com: string;
  grpChantier: {
    id: string;
    lib: string;
  };
  vehicule: {
    bbx: string;
    lib: string;
    imm: string;
  };

  public dataTableColor = '#ffffff';

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return '';
  }

  toExport(): ReportDetailExportInterface {
    return {
      time: this.heureDebut,
      duration: this.duree,
      km: this.km,
      position: this.position,
      com: this.com,
      address: this.adresse,
      site: this.chantier as string,
    };
  }

  serialize(): any {
    return {};
  }
}
